module.exports = __webpack_public_path__ + "static/media/recovered.bc6dc1a1.png";